var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isHomePage === false)?_c('div',{staticClass:"back-button"},[_c('v-btn',{attrs:{"large":"","icon":""},on:{"click":_vm.goback}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("keyboard_backspace")])],1)],1):_vm._e(),_vm._v(" "),_c('v-img',{staticClass:"mt-5 text-xs-center",attrs:{"src":_vm.myLogo,"height":"65px","contain":""}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a8cd9a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeader.vue
// module id = cKEC
// module chunks = 0